/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecordingCapHitsBucketFromJSON, RecordingCapHitsBucketToJSON } from './RecordingCapHitsBucket';
/**
 * Check if a given object implements the RecordingCapHitsResponse interface.
 */
export function instanceOfRecordingCapHitsResponse(value) {
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('free' in value) || value['free'] === undefined)
        return false;
    if (!('hoursSinceLastEventEver' in value) || value['hoursSinceLastEventEver'] === undefined)
        return false;
    if (!('overall' in value) || value['overall'] === undefined)
        return false;
    if (!('paid' in value) || value['paid'] === undefined)
        return false;
    return true;
}
export function RecordingCapHitsResponseFromJSON(json) {
    return RecordingCapHitsResponseFromJSONTyped(json, false);
}
export function RecordingCapHitsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'days': json['days'],
        'free': RecordingCapHitsBucketFromJSON(json['free']),
        'hoursSinceLastEventEver': json['hoursSinceLastEventEver'],
        'overall': RecordingCapHitsBucketFromJSON(json['overall']),
        'paid': RecordingCapHitsBucketFromJSON(json['paid']),
    };
}
export function RecordingCapHitsResponseToJSON(json) {
    return RecordingCapHitsResponseToJSONTyped(json, false);
}
export function RecordingCapHitsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'days': value['days'],
        'free': RecordingCapHitsBucketToJSON(value['free']),
        'hoursSinceLastEventEver': value['hoursSinceLastEventEver'],
        'overall': RecordingCapHitsBucketToJSON(value['overall']),
        'paid': RecordingCapHitsBucketToJSON(value['paid']),
    };
}
